import { CommonAPIService } from './common.service';
import { inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DwService {
  private commonService = inject(CommonAPIService);

  getCameraList() {
    return this.commonService.get('/DW/camera-list');
  }

  getLayoutList() {
    return this.commonService.get('/DW/layout-list');
  }

  getServerList() {
    return this.commonService.get('/DW/serverList');
  }

  createLayout(payload: any) {
    return this.commonService.post('/DW/layout/create', payload);
  }

  updateLayout(layoutId: string, payload: any) {
    return this.commonService.put(`/DW/layout/update/${layoutId}`, payload);
  }

  deleteLayout(layoutId: string) {
    return this.commonService.delete(`/DW/layout/delete/${layoutId}`);
  }

  getEventRuleAPIUrl(payload: {
    _id: any;
    dw_user_id?: string;
    user_id?: string;
    prefer_dkapi?: boolean;
  }) {
    const req: {
      _id: any;
      dw_user_id?: string;
      user_id?: string;
      prefer_dkapi?: boolean;
    } = { _id: payload._id };
    if (typeof payload._id === 'object' && payload._id?._id) {
      req._id = payload._id._id;
    }
    if (payload.dw_user_id) {
      req.dw_user_id = payload.dw_user_id;
    }
    if (payload.user_id) {
      req.user_id = payload.user_id;
    }
    if (payload.prefer_dkapi) {
      req.prefer_dkapi = true;
    }
    return this.commonService.post('/DW/getEventRuleAPIUrl', req);
  }

  // RTSP live view, snapshots, recording and playback are served by the Python media service
  // (see MediaService); this API no longer has those endpoints.
}
